/**
 * Decode JWT token and check if it's expired
 * @param {string} token - JWT token from localStorage
 * @returns {boolean} - true if token is valid, false if expired or invalid
 */
export const isTokenValid = (token) => {
  if (!token) {
    return false;
  }

  try {
    // JWT tokens have 3 parts separated by dots: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) {
      return false;
    }

    // Decode the payload (second part)
    const payload = JSON.parse(atob(parts[1]));
    
    // Check if token has expiration time
    if (!payload.exp) {
      return false;
    }

    // Compare expiration time with current time (exp is in seconds, Date.now() is in milliseconds)
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp > currentTime;
  } catch (error) {
    console.error('Error validating token:', error);
    return false;
  }
};

/**
 * Get token from localStorage
 * @returns {string|null} - Token or null if not found
 */
export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

/**
 * Check if user has valid authentication
 * @returns {boolean} - true if authenticated with valid token
 */
export const isAuthenticated = () => {
  const token = getAuthToken();
  return isTokenValid(token);
};
